<nz-card>

  <div class="col-12 mb-3">
    <button nz-button nzType="primary" class="admin-btn_create" style="margin-bottom: 0" (click)="create()">Tạo
      mới</button>
  </div>
  <app-search-filter [total]="queryParams.totalItems" (search$)="getValueSearch($event)">
    <div class="col-12">
      <div class="row">
        <div class="d-flex align-items-center">
          <i nz-icon nzType="search" class="opacity-05 mr-2"></i>
        </div>
        <div class="col-lg-3">
          <div class="d-md-flex">
            <nz-input-group>
              <input type="text" nz-input placeholder="Mã CCQ" [(ngModel)]="searchParams.productCode" 
              (ngModelChange)="eventSearchParams('productCode', searchParams.productCode)">
            </nz-input-group>
          </div>
        </div>

        <div class="col-lg-3">
          <div class="d-md-flex">
            <nz-input-group>
              <input type="text" nz-input placeholder="Tên SIP" [(ngModel)]="searchParams.programName" 
              (ngModelChange)="eventSearchParams('programName', searchParams.programName)">
            </nz-input-group>
          </div>
        </div>
       
      </div>
    </div>
  </app-search-filter>

  <nz-divider></nz-divider>
  <nz-table #listViewTable [nzData]="list" [nzShowPagination]="false" [nzFrontPagination]="false">
    <thead>
      <tr>
        <th>Mã CCQ</th>
        <th>Tên SIP</th>
        <th>Mã giao dịch</th>
        <th>Mua tối thiểu</th>
        <th>Bán tối thiểu</th>
        <th>Nắm giữ tối thiểu</th>
        <th>TG đầu tư tối thiểu</th>
        <th>Chu kỳ thanh toán</th>
        <th>Mã chu kỳ</th>
        <th>Tính phí theo <br /> kỳ GD đầu tiên</th>
        <!-- <th>Trạng thái</th> -->
        <th>Thao tác</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of listViewTable.data; trackBy: trackId; index as index">
        <td>{{item.productProgram?.product?.code}}</td>
        <td>{{item.productProgram?.name}}</td>
        <td>{{item.productProgram?.tradeCode}}</td>
        <td>{{item.productProgram?.buyMinValue | money}}</td>
        <td>{{item.productProgram?.sellMin | money}}</td>
        <td>{{item.productProgram?.holdingMin | money}}</td>
        <td>{{item.minCycleLength}}</td>
        <td>Hàng tháng</td>
        <td>{{item.sipCode}}</td>
        <td><input type="checkbox" name="" id="" [checked]="item.isFeeFromFirstTransaction"></td>
        <td>
          <button type="button" class="btn dropdown-toggle" data-toggle="dropdown">
             <i nz-icon nzType="menu" nzTheme="outline"></i>
            <span class="sr-only">Toggle Dropdown</span>
          </button>
          <div [ngClass]="(index > list.length - 3) && list.length > 3 && 'dropup'">
          <ul class="dropdown-menu" role="menu">
            <li><a (click)="edit(item.id)" title="Edit" class="ant-btn btn-edit"><i nz-icon nzType="edit"
                  nzTheme="outline"></i><span>Sửa đổi</span></a></li>
            <li><a (click)="transferFee(item)" title="Edit" class="ant-btn btn-edit"><i nz-icon nzType="edit"
              nzTheme="outline"></i><span>Phí chuyển đổi</span></a></li>

            <li><a (click)="addNewFee(item)" class="ant-btn btn-edit" title="Transfer fee">
              <i nz-icon nzType="sync" nzTheme="outline"></i><span>Phí mới</span></a>
            </li>
            <li><a (click)="confirmDelete(item)" title="Delete" class="ant-btn btn-edit"><i nz-icon nzType="stop"
                  nzTheme="outline"></i><span>Xóa</span></a></li>
          </ul>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>
  <div class="ant-table-pagination ant-pagination">
    <nz-pagination [nzPageIndex]="queryParams.page" [nzTotal]="queryParams.totalItems" [nzPageSize]="queryParams.size"
      [nzShowTotal]="rangeTemplate" (nzPageIndexChange)="loadPage($event)">
    </nz-pagination>
    <ng-template #rangeTemplate let-range="range" let-total>
      {{ range[0] }} - {{ range[1] }} of {{ queryParams.totalItems }} items
    </ng-template>
  </div>
</nz-card>